/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import Plaatjie from '@ubo/plaatjie'


// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import {ParseContent } from 'components/shared'
import Breadcrumb from 'components/elements/BreadCrumb'

const Hero = styled.section`
  background-size: 100% 400px;

  @media screen and (max-width: 991px) {
    background-size: cover !important;
  }
`

const HeroContent = styled.div`
  padding-top: 200px;
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`

const ModalContent = styled.div`
  background: #ffffff;
  max-width: 600px;
  width: 90%;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`

const ModalCloseButton = styled.button`
  border: 0;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 20px;
`

const PageTemplate = ({
  data: {
    page: { path, title, wordpress_id, yoast_meta: yoast, acf },
  },
  pageContext
}) => {

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false)

  useEffect(() => {
    if (!isDownloadModalOpen) return
    if (typeof window === 'undefined') return

    const existingScript = document.querySelector('script[data-ac-form="1"]')
    if (existingScript) return

    const script = document.createElement('script')
    script.src = 'https://kontado2.activehosted.com/f/embed.php?id=1'
    script.charset = 'utf-8'
    script.dataset.acForm = '1'
    document.body.appendChild(script)
  }, [isDownloadModalOpen])

  const handleOpenDownloadModal = () => {
    setIsDownloadModalOpen(true)
  }

  const handleCloseDownloadModal = () => {
    setIsDownloadModalOpen(false)
  }


  return (
    <Layout noNewsletter={wordpress_id === 2010}>
      <SEO yoast={yoast} path={path} />

      <Hero
        className="hero-image-small"
        style={{
          backgroundImage: `url(${acf.banner.background.localFile.childImageSharp.fluid.src})`
        }}
      >
        <HeroContent className="container">
          <div className="mb-3">
            <ParseContent
              className="color-light text-center text-lg-left"
              content={acf.banner.description}
            />
          </div>
          <Breadcrumb data={title} className="py-0" pageContext={pageContext} />
        </HeroContent>
      </Hero>

      <div className="container py-5">
        <div className="px-lg-5">
          <ParseContent
            content={acf.meta.description}
            onDownloadClick={handleOpenDownloadModal}
          />
        </div>
      </div>

      <ModalOverlay
        onClick={handleCloseDownloadModal}
        style={{ display: isDownloadModalOpen ? 'flex' : 'none' }}
      >
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <ModalCloseButton type="button" onClick={handleCloseDownloadModal}>
            ×
          </ModalCloseButton>

          <div className="_form_1" />
        </ModalContent>
      </ModalOverlay>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path
      wordpress_id

      acf {
        banner {
          description
          background {
          localFile {
            publicURL
            childImageSharp {
              fluid(toFormat: WEBP, maxWidth: 2000, quality:100) {
                src
              }
            }
          }
        }
        }

        meta {
          description
        }
      }
      
      yoast_meta {
        name
        content
        property
      }
    }
  }
`

export default PageTemplate
